
export default class events
{
    constructor()
    {
        this._fancyDate();

        if ( $('.all-sites-js').length ) {
            $('.all-sites-js').click(function () {
                $('.site-js input').prop('checked', false);
            });

            $('.site-js').click(function () {
                $('.all-sites-js input').prop('checked', false);
            });
        }
    }

    _fancyDate()
    {
        // loop through each event
        let $event = $('.event-js');
        $event.each(function () {
            let $date = $(this).find('.get-event-date-js');
            let $time = $(this).find('.event-time-js');
            let $append = $(this).find('.append-date');

            $time.text(moment( $time.text(), 'HH:mm:ss').format('hh:mm A'));

            // loop through each date for each event
            $date.each(function (i) {

                // format the date
                $(this).text( moment( $(this).text(), 'YYYY-MM-DD' ).format('MMMM DD, YYYY') );

                // fetch the month/day to append to the fancy box on the left
                let shortMonth = moment( $(this).text(), 'LL' ).format( 'MMM' );
                let day = $(this).text().substr( 0, $(this).text().indexOf(',') ).split(' ')[1];

                var template = `<div class="event-date-background">
                    <div class="event-date event-date-js">
                        <span class="month">${shortMonth}</span>
                        <span class="day">${day}</span>
                    </div>
                </div>
                `;



                $append.append(template)

                if ( $date.length > 1 && i < ($date.length - 1) ) {
                    let divider = document.createElement('div');
                    divider.setAttribute('class', 'divider');

                    $append.appendChild( divider );
                }
            });
        });
    }
}
